/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';

const HiddenInvitationsToggle = ({
  isExpandedInvites,
  garageInvitesLength,
  collapseInvites,
  expandInvites,
  displayedBookingInvitesLength,
}) => {
  const hiddenInvitesLength = garageInvitesLength - displayedBookingInvitesLength;
  const toggleHiddenInvites = () => (isExpandedInvites ? collapseInvites() : expandInvites());

  return (
    <div className="hidden-invites-toggle" onClick={toggleHiddenInvites}>
      Click to {isExpandedInvites ? 'hide' : 'see'} cancelled, declined or expired invitations&nbsp;
      {hiddenInvitesLength ? `(${hiddenInvitesLength})` : ''}
    </div>
  );
};

export default HiddenInvitationsToggle;

HiddenInvitationsToggle.propTypes = {
  isExpandedInvites: PropTypes.bool.isRequired,
  garageInvitesLength: PropTypes.number.isRequired,
  collapseInvites: PropTypes.func.isRequired,
  expandInvites: PropTypes.func.isRequired,
  displayedBookingInvitesLength: PropTypes.number.isRequired,
};
